import useSyncHelper from './useSyncHelper';
import { deleteStowagePlanItem, getAllStowagePlanItems } from 'src/api/stowage/offlineStowageApi';

const useSyncOfflineStowageData = () => {
    const { syncItems } = useSyncHelper();

    const syncStowagePlanData = () =>
        syncItems(
            getAllStowagePlanItems,
            deleteStowagePlanItem,
            ['addStowagePlanRequest', 'updateStowagePlanRequest', 'saveStowageDataRequest'],
            'stowagePlanGuid'
        );

    return {
        syncStowagePlanData,
    };
};

export default useSyncOfflineStowageData;
